import React from 'react';

/**
 * Shared “What this means” layout: highlighted hero metric, tagline, callout, contrast, footnote.
 * Pair with the ? toggle on calculator result panels.
 */
export default function CalculatorWhatThisMeans({
  pill,
  heroValue,
  heroSuffix,
  /** 'number' — large years/count; 'inr' — slightly smaller for currency strings */
  heroVariant = 'number',
  tagline,
  highlight,
  highlightTone = 'warning',
  contrast,
  foot,
  regionLabel = 'Explanation of this result',
}) {
  const showHero =
    pill ||
    heroValue !== undefined ||
    heroSuffix;

  return (
    <div
      className="calc-wtm-explain"
      role="region"
      aria-label={regionLabel}
    >
      {showHero ? (
        <div className="calc-wtm-hero">
          {pill ? <span className="calc-wtm-pill">{pill}</span> : null}
          {heroValue !== undefined && heroValue !== null ? (
            <span
              className={`calc-wtm-hero-value${
                heroVariant === 'inr' ? ' calc-wtm-hero-value--inr' : ''
              }`}
            >
              {heroValue}
            </span>
          ) : null}
          {heroSuffix ? (
            <span className="calc-wtm-hero-suffix">{heroSuffix}</span>
          ) : null}
        </div>
      ) : null}
      {tagline ? <div className="calc-wtm-tagline">{tagline}</div> : null}
      {highlight ? (
        <p
          className={`calc-wtm-highlight${
            highlightTone === 'success' ? ' calc-wtm-highlight--good' : ''
          }`}
        >
          {highlight}
        </p>
      ) : null}
      {contrast ? (
        <p className="calc-wtm-contrast">{contrast}</p>
      ) : null}
      {foot ? <p className="calc-wtm-foot">{foot}</p> : null}
    </div>
  );
}
